import {adminRequest, requireData} from './adminRequest';
import {adminCitiesEndpoint, adminCityEndpoint} from '../constants/endpoints';

export interface AdminCity {
  code: number;
  // Also the key places and events are matched on (Google's city name).
  name: string;
  // County code as Google gives it, e.g. "CJ".
  county: string;
  // Display name of the county, with diacritics.
  region?: string | null;
  countryCode: string;
  timeZoneId: string;
  cityRangeKm: number;
  latitude: number;
  longitude: number;
  photoUrl?: string | null;
  placeCount: number;
  eventCount: number;
  userCount: number;
}

export type UpdateCityInput = Partial<
  Pick<
    AdminCity,
    | 'name'
    | 'county'
    | 'countryCode'
    | 'timeZoneId'
    | 'cityRangeKm'
    | 'latitude'
    | 'longitude'
  >
> & {
  // An empty string clears the value.
  region?: string;
  photoUrl?: string;
};

export interface UpdateCityResult {
  location: AdminCity;
  rebuildStarted: boolean;
  addressesRenamed: number;
}

export const fetchAdminCities = async (): Promise<AdminCity[]> =>
  (await adminRequest<AdminCity[]>(
    {endpoint: adminCitiesEndpoint, method: 'GET'},
    'Failed to fetch cities',
  )) ?? [];

export const updateCity = async (
  code: number,
  input: UpdateCityInput,
): Promise<UpdateCityResult> =>
  requireData(
    await adminRequest<UpdateCityResult, UpdateCityInput>(
      {endpoint: adminCityEndpoint(code), method: 'PATCH', body: input},
      'Failed to update the city',
    ),
    'Failed to update the city',
  );
